import styled from "styled-components";
import Button from "@8x8/oxygen-button";

export const FilterContainer = styled.div`
  padding-left: 16px;
  padding-right: 16px;
  min-width: 268px;
`;

export const FilterActionsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

export const FilterSelectWrapper = styled.div`
  flex-grow: 1;
  margin-left: 16px;
  min-width: 108px;
`;

export const RemoveFilterButton = styled(Button)`
  margin-left: 16px;
  box-shadow: none;
`;

export const FilterComponentsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

export const EllipsisOverflowSpan = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
